import React from 'react'
import { useHotkey } from 'react-hotkeys'
import { memo } from '~/ui/component'
import { useSimpleDrag } from '~/ui/hooks'
import { createUseStyles, layout } from '~/ui/styling'
import { useCalendarLayout } from './CalendarLayoutContext'
import { SelectionExtent, useSelection } from './SelectionContext'

const SelectLayer = memo('SelectLayer', () => {

  const {manager} = useSelection()
  const {screenYToTimeOfDay} = useCalendarLayout()

  //------
  // Layout

  const containerRef = React.useRef<HTMLDivElement>(null)

  const clientPointToSelectionExtent = React.useCallback((point: Point): SelectionExtent => {
    return {
      point: point,
      time:  screenYToTimeOfDay(point.y),
    }
  }, [screenYToTimeOfDay])

  //------
  // Drag handlers

  const [connectDrag] = useSimpleDrag({
    onMove: point => {
      const extent = clientPointToSelectionExtent(point)
      manager?.extendSelectionBounds(extent)
    },

    onEnd: (_, delta) => {
      if (delta.x === 0 && delta.y === 0) {
        manager?.deselectAll()
      }
      manager?.clearSelectionBounds()
    },
  })

  useHotkey('Escape', React.useCallback(() => {
    if (manager == null) { return }
    if (manager.selectedUUIDs.length === 0) { return }
    manager.deselectAll()
  }, [manager]))

  const connect = connectDrag(containerRef)

  //------
  // Rendering

  const $ = useStyles()

  function render() {
    return (
      <div
        classNames={$.selectLayer}
        ref={connect}
      />
    )
  }

  return render()

})

export default SelectLayer

export const height = layout.barHeight.s

const useStyles = createUseStyles({
  selectLayer: {
    ...layout.overlay,
  },
})